module.exports = __webpack_public_path__ + "components/rewards/treads-and-trails/static/logo-ee574cc7f1741fbee0f0f68b42911c6c.jpg";